import { Link } from "react-router-dom";
import { categoryPath } from "../../lib/slug";

type CategoryBadgeProps = {
  category: string;
};

export function CategoryBadge({ category }: CategoryBadgeProps) {
  return (
    <Link className="category-badge" to={categoryPath(category)}>
      {category}
    </Link>
  );
}
